import React, { useState, useEffect, useContext } from 'react'
import { ContentInner } from '../../layout/Content'
import StockInItemInnerStyle from './css/StockInItemInnerStyle'
import { formatNumber } from '../../utilities/utilities'
import PrinterSettingsStyle from '../../../css/PrinterSettingsStyle'
import { stockInItemControllerContext } from './StockInItemController'

function StockInItemInner() {
  const stockInItemController = useContext(stockInItemControllerContext)
  const { stockInItem } = stockInItemController
  const [summary, setSummary] = useState(null)

  const foundNoneExistingItem = Boolean(stockInItem.item_details.find((item) => (!item.exist)))

  useEffect(() => {
    if (stockInItem.item_details.length > 0) {
      // Total total
      const totalTotal = stockInItem.item_details
      .map(id => id.total)
      .reduce((prevTotal, curTotal) => (prevTotal + curTotal))

      setSummary({ totalTotal })
    }

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ContentInner>
      <div className='stockin-wrapper'>
        <div className='stock-in-item-container printable'>
          <div className='stock-in-header-container'>
            <label>Stock In - {stockInItem._id.toUpperCase()}</label>
          </div>
          <div className='stock-in-header-details-container'>
            <div className='fields-group-container' id='group-1-fields-container'>
              {
                (stockInItem.warehouse) ?
                <div className='field-group' id='destination-warehouse-group'>
                  <label>Destination Warehouse</label>
                  <p>{stockInItem.warehouse.name}</p>
                </div>
                : null
              }
              <div className='field-group' id='date-time-created-group'>
                <label>Date Time Created</label>
                <p>{new Date(stockInItem.date_time_created).toLocaleString('en-us', { timeZone: stockInItem.client_timezone })} { stockInItem.client_timezone }</p>
              </div>
              <div className='field-group' id='received_by-group'>
                <label>Received By</label>
                <p>{stockInItem.received_by}</p>
              </div>
              <div className='field-group' id='supplier-name-group'>
                <label>Supplier</label>
                <p>{stockInItem.supplier_name}</p>
              </div>
            </div>
            <div className='spacer'></div>
            <div className='fields-group-container' id='group-2-fields-container'>
              <div className='field-group' id='date-received-group'>
                <label>Date Received</label>
                <p>{new Date(stockInItem.date_received).toLocaleString("en-us", { timeZone: stockInItem.client_timezone }).split(',')[0]} { stockInItem.client_timezone }</p>
              </div>
              <div className='field-group' id='reference_code-group'>
                <label>Reference</label>
                <p>{stockInItem.reference_code.toUpperCase()}</p>
              </div>
              <div className='field-group'>
                <label>Remarks</label>
                <p>{stockInItem.remarks}</p>
              </div>
              <div className='field-group'>
                <label>Status</label>
                <p>{stockInItem.status}</p>
              </div>
            </div>
          </div>
          <table className='item-details-table striped-table'>
            <thead>
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Unit</th>
                <th style={{textAlign: 'center'}}>Quantity</th>
                <th style={{textAlign: 'center'}}>FOB</th>
                <th style={{textAlign: 'center'}}>Total</th>
                <th>Remarks</th>
                { (foundNoneExistingItem) ? <th>Status</th> : null }
              </tr>
            </thead>
            {
              stockInItem.item_details.map((item_detail, index) => (
                <tbody key={item_detail.id+index}>
                  <tr>
                    <td>{index+1}</td>
                    <td className='item-name-container'>
                      <div className='item-name'>{item_detail.name}</div>
                      <div
                        style={{display: (item_detail.expiration_date) ? 'block' : 'none'}}
                        className='expiration-date-container'>
                        Expiration Date:&nbsp; <span className='expiration-date'>{item_detail.expiration_date}</span>
                      </div>
                    </td>
                    <td>{item_detail.unit}</td>
                    <td style={{textAlign: 'center'}}>{item_detail.quantity}</td>
                    <td style={{textAlign: 'right'}}>P{formatNumber(item_detail.fob)}</td>
                    <td style={{textAlign: 'right'}}>P{formatNumber(item_detail.total)}</td>
                    <td>{item_detail.remarks}</td>
                    { (foundNoneExistingItem && (stockInItem.status === 'Posted'))
                      ? (!item_detail.exist)
                        ? <td><span style={{color: 'red'}}>Not Found</span></td>
                        : <td><span style={{color: 'blue'}}>OK</span></td>
                      : null
                    }
                  </tr>
                </tbody>
              ))
            }
            {
              (summary) ?
                <tbody>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td style={{textAlign: 'center', fontWeight: 'bold'}}>Total</td>
                    <td style={{textAlign: 'right', fontWeight: 'bold'}}>P{formatNumber(summary.totalTotal)}</td>
                    <td></td>
                  </tr>
                </tbody>
              : null
            }
          </table>
        </div>
        <div className='log-container'>
          <div className='created-by'>
            Created by {stockInItem.log.created_by.name} on {new Date(stockInItem.date_time_created).toLocaleString('en-us', { timeZone: stockInItem.client_timezone })} { stockInItem.client_timezone }
          </div>
          {
            (stockInItem.log.last_modified_by)
            ? <div className='last-modified-by'>
                Last modified by {stockInItem.log.last_modified_by.name} on {new Date(stockInItem.date_time_modified).toLocaleString('en-us', { timeZone: stockInItem.client_timezone})} { stockInItem.client_timezone }
              </div>
            : null
          }
        </div>
        <StockInItemInnerStyle />
        <PrinterSettingsStyle paperWidth='8.5inch'/>
      </div>
    </ContentInner>
  )
}

export default React.memo(StockInItemInner)